import { useState } from "react";
import { TimeCountdown } from "../TimeCountdown/TimeCountdown";
import styles from "./QuizQuestionBlock.module.scss";
import { useDispatch, useSelector } from "../../../../hooks";
import { quizAnswer } from "../../../../redux/quizzes/quiz-answer.handler";
import { Button } from "../../../../components/Buttons/Button/Button";
import { AppContext } from "../../../../components/Menu/MenuButton";
import { ActionsContext } from "../../../ActionsPage/ACtionsRoutes";
import { useNavigate } from "react-router-dom";

export const QuizQuestionBlock = () => {
    const [selectedAnswerIndex, setSelectedAnswerIndex] = useState(-1);

    const quiz = useSelector(store => store.quiz.quiz);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    if (!quiz) {
        navigate(`/${AppContext.Actions}/${ActionsContext.Tasks}`, { replace: true });
        return <></>;
    }

    const answerHandler = () => {
        if (selectedAnswerIndex < 0)
            return;

        dispatch(quizAnswer(selectedAnswerIndex));
    }

    return (
        <div className={styles.quizContainer}>
            <p className={styles.question}>
                { quiz.question.questionText }
            </p>

            <div className={styles.quizBlock}>
                <div className={styles.questionsBlock}>
                    { quiz.question.answers.map((answer) => (
                        <label
                            key={`answer${answer.index}`}
                            className={`${styles.quizItem} ${selectedAnswerIndex === answer.index ? styles.selected : ""}`}
                        >
                            <span className={styles.quizText}>{answer.text}</span>
                            <input
                                type="radio"
                                name="quiz"
                                checked={selectedAnswerIndex === answer.index}
                                onChange={() => setSelectedAnswerIndex(answer.index)}
                            />
                            <span className={styles.radioCustom}></span>
                        </label>
                    ))}
                </div>

                <TimeCountdown />

                { selectedAnswerIndex >= 0 && 
                    <div className={styles.button}>
                        <Button caption="Ответить" handler={ answerHandler } />
                    </div>
                }
            </div>
        </div>
    );
}